import React from 'react';
import { withRouter, WithRouterProps } from 'react-router';
import { get as getCookie } from 'js-cookie';

import { withPrefix } from '../i18n_helpers';
import { Filter } from './search_filters';
import Popover from './popover';
import FilterChip from './filter_chip';
import RegionSelectFilter from './region_select_filter';
import { useUser } from '../user_hooks';

const sellerLocationFilterRegions = ['GB', 'AU'];

interface IExternalProps {
  filters: Filter[];
  loading: boolean;
}

type IProps = IExternalProps & WithRouterProps;

const t = withPrefix('commons.sellerLocationSearchFilter');

export function SellerLocationSearchFilter(props: IProps) {
  const user = useUser();
  const { filters, loading } = props;
  const sellerLocationFilter = getSellerLocationFilter(filters);

  if (!showSellerLocationFilter(user) || !sellerLocationFilter) { return null; }

  return (
    <Popover
      trigger={
        <FilterChip
          withDropdown
          loading={loading}
          selected
        >
          {getFilterText(sellerLocationFilter)}
        </FilterChip>
      }
      loading={loading}
    >
      <RegionSelectFilter filter={sellerLocationFilter} key="seller-location" />
    </Popover>
  );
}

export function getDefaultSellerLocation(user, queryParams) {
  if (queryParams.item_region) {
    return queryParams.item_region;
  }

  if (user.shippingRegionCode === 'GB') {
    if (getCookie('itemRegionOverride')) {
      return getCookie('itemRegionOverride');
    }

    return user.shippingRegionCode;
  }
}

export function showSellerLocationFilter(user) {
  return sellerLocationFilterRegions.includes(user.shippingRegionCode);
}

function getSellerLocationFilter(filters) {
  return filters.find((f) => {
    return f.key === 'SELLER_LOCATION';
  });
}

function getFilterText(filter) {
  const sellerLocationOption = filter.options.find((option) => option.selected);

  return t('buttonText', { itemRegion: sellerLocationOption.name });
}

export default withRouter(SellerLocationSearchFilter);
